import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IUser } from "@formant/core/model/IUser";

import { appStore, authStore, userStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    user: IUser;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        const { user } = this.props;

        const isSelf = authStore.userId === user.id;

        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    disabled={isSelf}
                    onClicked={this.onDelete}
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { user } = this.props;
        appStore.setConfirm({
            title: "Delete user",
            message: `Delete ${
                user.isServiceAccount ? "service account" : "user"
            } "${user.firstName}"?`,
            onOk: async () => {
                await userStore.disable(defined(user.id));
                appStore.setSnackbar("User deleted");
            },
        });
    };
}
